export class PentagoFailure {
    static CANNOT_ROTATE_NEUTRAL_BLOCK = () => $localize `If the quadrant to turn is neutral, please just use move without rotation.`;
    static MUST_CHOOSE_BLOCK_TO_ROTATE = () => $localize `No quadrant is neutral, you must pick a quadrant to rotate.`;
}
